export type EnvironmentConfig = {
    ivdr: boolean
}

declare global {
    interface Window {
        EXPERT_ENV?: Partial<EnvironmentConfig>
    }
}

const defaultConfig: EnvironmentConfig = {
    ivdr: false
}

const readConfig = (): EnvironmentConfig => {
    const runtimeConfig = window.EXPERT_ENV

    if (!runtimeConfig) {
        console.warn(
            'Expert: no runtime configuration found – env.js is missing or was not loaded. Falling back to the non-IVDR defaults.'
        )

        return defaultConfig
    }

    return {
        ivdr:
            typeof runtimeConfig.ivdr === 'boolean'
                ? runtimeConfig.ivdr
                : defaultConfig.ivdr
    }
}

export const environmentConfig = readConfig()

export const isIvdrDeployment = environmentConfig.ivdr
